module.exports = __webpack_public_path__ + "static/content-03-027382f35e29d3b31d54f178655c5211.jpg";